import { planningAPI } from "../../axios";

export const actions = {
     // DepartmentPlanningApi
    AddDepartmentPlanningApi(context, data){
        return planningAPI.post(`DepartmentPlanningApi/Add`, data);
    },
    GetSingleDepartmentPlanningApi(context, data){
        return planningAPI.get(`DepartmentPlanningApi/${data}`);
    },
    UpdateDepartmentPlanningApi(context, data){
        return planningAPI.put(`DepartmentPlanningApi/${data.id}`, data);
    },
    RemoveDepartmentPlanningApi(context, data){
        return planningAPI.delete(`DepartmentPlanningApi/${data}`);
    },
    GetAllDepartmentPlanningApi(context, data){
        return planningAPI.get(`DepartmentPlanningApi/All/${data}`);
    },
    ImportDepartmentPlanningApi(context, data){
        return planningAPI.post(`DepartmentPlanningApi/Import/${data.opcrId}`, data.ids);
    },
    GetPlanningApisByTargetAndOPCR(context, data){
        return planningAPI.get(`DepartmentPlanningApi/Target/${data.preplanningTargetId}/${data.departmentPreOpcrId}`);
    },
}